import { Box, styled } from "@mui/material";

import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";

import SettingsPanel from "~/features/settings/SettingsPanel";
import { SystemStatus } from "~/features/status/SystemStatus";
import { selectServerConfig } from "~/redux/selectors/appSelectors";
import { selectUsersFulfillmentCenter } from "~/redux/selectors/storeSelectors";

import AdminSummariesView from "./adminSummaries/AdminSummariesView";

const ServiceSupportContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "2fr 1fr",
  gridTemplateRows: "auto",
  gap: theme.spacing(3),
  alignItems: "flex-start",
  "@media (max-width: 1200px)": {
    gridTemplateColumns: "1fr"
  },
  padding: theme.spacing(3),
  paddingBottom: 0,
  height: "100%"
}));

const ServiceSupport = () => {
  const { t } = useTranslation();
  const usersFulfillmentCenter = useAppSelector(selectUsersFulfillmentCenter);
  const { an_andonFeaturesEnabled } = useAppSelector(selectServerConfig);

  const pickingConfigurations = usersFulfillmentCenter?.pickingConfigurations;

  return (
    <ServiceSupportContainer>
      {an_andonFeaturesEnabled && (
        <SettingsPanel
          panelTitle={t("admin summaries")}
          sx={{ gridColumn: "span 2" }}
        >
          <AdminSummariesView />
        </SettingsPanel>
      )}
      {pickingConfigurations?.includes("Autostore") && (
        <SettingsPanel panelTitle={t("system status")}>
          <SystemStatus />
        </SettingsPanel>
      )}
    </ServiceSupportContainer>
  );
};

export default ServiceSupport;
